// cart-fbt.js — global event delegation for Frequently Bought With upsell in cart drawer.
// Loaded once from layout/theme.liquid; survives all cart drawer re-renders (SRA innerHTML swaps).
(function () {
  if (window.__cartFbtLoaded) return;
  window.__cartFbtLoaded = true;

  async function refreshCartDrawer() {
    try {
      // Prefer Horizon/Tinker's cart update event if available
      const CartUpdateEvent = window.CartUpdateEvent;
      if (CartUpdateEvent) {
        try {
          document.dispatchEvent(new CartUpdateEvent({}, 'cart-fbt', { source: 'cart-fbt' }));
          return;
        } catch (_) { /* fall through to manual */ }
      }
      // Fallback: fetch fresh cart drawer via Section Rendering API + swap innerHTML
      const sec = await fetch('/cart?section_id=cart-drawer-section');
      if (!sec.ok) return;
      const html = await sec.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#shopify-section-cart-drawer-section');
      const current = document.querySelector('#shopify-section-cart-drawer-section');
      if (!fresh || !current) return;

      const wasDialogOpen = !!current.querySelector('dialog[open]');
      current.innerHTML = fresh.innerHTML;

      // Re-open dialog if it was open (avoids close-then-reopen flicker)
      if (wasDialogOpen) {
        const dlg = current.querySelector('dialog');
        if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
          try { dlg.showModal(); } catch (_) {}
        }
      }
      // Notify any other listeners
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'cart-fbt' } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'cart-fbt' } }));
    } catch (e) { /* ignore */ }
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-fbt-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    const container = btn.closest('.cart-fbt');
    const variantId = container && container.getAttribute('data-fbt-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    const text = btn.querySelector('.cart-fbt__button-text');
    const loading = btn.querySelector('.cart-fbt__button-loading');
    if (text) text.hidden = true;
    if (loading) loading.hidden = false;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed ' + res.status);
      await refreshCartDrawer();
    } catch (err) {
      console.warn('[cart-fbt] add failed:', err);
      btn.disabled = false;
      if (text) text.hidden = false;
      if (loading) loading.hidden = true;
    }
  }, { passive: false });
})();
